import React from 'react';
import { useMutation } from '@apollo/client';
import {
  FavoriteEntityType,
  IFavoriteVersionEntityMutation,
  IFavoriteVersionEntityMutationVariables,
} from '../../utils/apollo/graphqlSchema';
import { FAVORITE_VERSION_ENTITY } from '../../utils/apollo/favorite/mutations';
import printGraphqlErrors from '../../utils/apollo/printGraphqlErrors';
import { assertNotNil } from '../../utils/types';
import toastMessage from '../../utils/toastMessage';
import { FavoriteStarIcon, IconWrapper } from '../Icon';
import { colors } from '../../config/styles';

interface IProps {
  dashboardBaseId: string;
  isFavorite: boolean;
  onToggle?: () => void;
}

const FavoriteDashboardInstance = ({
  dashboardBaseId,
  isFavorite,
  onToggle,
}: IProps) => {
  const handleMutationComplete = ({
    favoriteVersionEntity,
  }: IFavoriteVersionEntityMutation) => {
    const { errors, message } = favoriteVersionEntity;
    if (printGraphqlErrors(errors)) {
      return;
    }

    assertNotNil(message);
    toastMessage({ message, type: 'info' });

    if (onToggle) {
      onToggle();
    }
  };

  const [setFavorite] = useMutation<
    IFavoriteVersionEntityMutation,
    IFavoriteVersionEntityMutationVariables
  >(FAVORITE_VERSION_ENTITY, {
    onCompleted: handleMutationComplete,
  });

  const toggleFavorite = () => {
    setFavorite({
      variables: {
        input: {
          entityId: dashboardBaseId,
          entityType: FavoriteEntityType.Dashboard,
          isFavorite: !isFavorite,
        },
      },
    });
  };

  return (
    <IconWrapper
      size={24}
      onClick={toggleFavorite}
      hoverColor={colors.favoriteGoldTitle}
    >
      <FavoriteStarIcon size={16} isActive={isFavorite} />
    </IconWrapper>
  );
};

export default FavoriteDashboardInstance;
